import { render, staticRenderFns } from "./c-cascader-address.vue?vue&type=template&id=27646a76&scoped=true"
import script from "./c-cascader-address.vue?vue&type=script&lang=js"
export * from "./c-cascader-address.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27646a76",
  null
  
)

export default component.exports